'use client';
import { useState, useCallback } from 'react';
import { useInterval } from '../useInterval/useInterval.js';

const useIntervalControls = (callbackFn, interval, options = {
    autoStart: true
})=>{
    const { autoStart } = options;
    const [active, setActive] = useState(autoStart);
    const start = useCallback(()=>setActive(true), []);
    const stop = useCallback(()=>setActive(false), []);
    useInterval(callbackFn, active ? interval : null);
    return {
        start,
        stop,
        active
    };
};

export { useIntervalControls };
//# sourceMappingURL=useIntervalControls.js.map
